var map = {
	"./home-entertainment.de-CH.json": 1474,
	"./home-entertainment.de-DE.json": 1475,
	"./home-entertainment.en-CA.json": 1476,
	"./home-entertainment.en-GB.json": 1477,
	"./home-entertainment.en-IN.json": 1478,
	"./home-entertainment.en-ME.json": 1479,
	"./home-entertainment.en-US.json": 1480,
	"./home-entertainment.es-EM.json": 1481,
	"./home-entertainment.es-ES.json": 1482,
	"./home-entertainment.fr-BE.json": 1483,
	"./home-entertainment.fr-CA.json": 1484,
	"./home-entertainment.fr-CH.json": 1485,
	"./home-entertainment.nl-BE.json": 1486,
	"./home-entertainment.nl-NL.json": 1487,
	"./home-entertainment.pl-PL.json": 1488,
	"./home-entertainment.pt-BR.json": 1489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1473;